import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router';
import { tryFormatDateTime } from '../../../common/utils/dateUtils';
import { useNavigationPaths } from '../../propertyAssociation/useNavigationPaths';
import { TableRow } from '../../shared/Table';
import { PinboardMessage } from '../models/GetPinboardMessagesResponse';
import styles from './PinboardMessageItem.module.scss';

type Props = PinboardMessage;

const PinboardMessageItem: FunctionComponent<Props> = ({ propertyAssociationArea, publishDate, unpublishDate, pinboardMessageId, title, usersCanRespond, isPinned }) => {
    const navigate = useNavigate();
    const paths = useNavigationPaths();

    const goToEdit = () => {
        navigate(`${paths.adverts}/information/${pinboardMessageId}`);
    };

    const heading = propertyAssociationArea ? `${title} (${propertyAssociationArea.name})` : title;

    return (
        <TableRow onClick={goToEdit}>
            <td>
                {isPinned ? (
                    <span role="img" aria-label="Fastnålat">
                        📌
                    </span>
                ) : (
                    <span aria-label="Ej fastnålat">–</span>
                )}
            </td>
            <td>
                <a
                    href={`${paths.adverts}/information/${pinboardMessageId}`}
                    onClick={(e) => {
                        e.preventDefault();
                    }}
                    className={styles.link}
                >
                    <h4 className="my-0">{heading}</h4>
                </a>
            </td>
            <td>{usersCanRespond ? 'Boende kan svara' : 'Boende kan inte svara'}</td>
            <td>{tryFormatDateTime(publishDate)}</td>
            <td className="text-muted">{unpublishDate ? tryFormatDateTime(unpublishDate) : <span aria-label="Inget avpubliceringsdatum">–</span>}</td>
        </TableRow>
    );
};

export default PinboardMessageItem;
